module.exports = __webpack_public_path__ + "img/appAsset-cardbrand--RedCompra.f4409222.svg";